import { SET_EXTERNAL_DATA } from "../constants/constants";

export const setExternalData = (payload: any) => {
    return async (dispatch) => {
        await dispatch({ type: SET_EXTERNAL_DATA, payload });
    }
}